import { createDetailedValidator } from 'typecheck.macro';
import { makeAlgoliaIndex } from '../../schema/public-algolia/AlgoliaIndex';
import { useAlgoliaAutoComplete } from './useAutoComplete';

export const useAutoCompleteSuburbs = (input?: string) =>
  useAlgoliaAutoComplete(SuburbIndex, input).map(({ suburb, state, postcode }) => ({
    label: `${suburb}, ${state} ${postcode}`,
    value: suburb,
    data: { suburb: suburb, state: state, postcode: postcode },
  }));

const SuburbIndex = makeAlgoliaIndex(
  'Suburbs',
  createDetailedValidator<{ suburb: string; state: string; postcode: string }>(),
);
